import { LoginUserInformation, UserInformation } from "../../../interfaces";
import userHelper from "../../../utils/userHelper";

export const mapCognitoToUserInformation = (
  cognitoUserData: LoginUserInformation
): UserInformation => {
  const {
    given_name = "",
    "custom:cuit": cuit = "",
    email = "",
    "cognito:username": uid = "",
    "custom:codagencia": codigoDeAgencia = "",
    "custom:codemp": codigoDeEmpresa = "",
    "custom:codsuc": codigoDeSucursal = "",
    "custom:usrinterno": usuarioInterno = "",
  } = cognitoUserData;

  return {
    cn: given_name,
    sn: given_name,
    cuit: Number(cuit),
    mail: email,
    uid,
    codigoDeAgencia: Number(codigoDeAgencia),
    codigoDeEmpresa,
    codigoDeSucursal,
    usuarioInterno,
    intermediarioPrincipal: null,
    intermediarioSecundario: null,
  };
};

export const isTokenExpired = (token: string) => {
  const payload = userHelper.parseUserJwt(token);
  const exp = payload?.exp;
  if (!exp) return true;
  return Date.now() >= exp * 1000;
};

export const translateCognitoError = (code: string): string => {
  const translations: Record<string, string> = {
    "UserNotFoundException": "El usuario no existe.",
    "NotAuthorizedException": "Usuario o contraseña incorrectos.",
    "UserNotConfirmedException": "El usuario no ha confirmado su cuenta.",
    "TooManyRequestsException": "Demasiadas solicitudes. Intente nuevamente más tarde.",
    "PasswordResetRequiredException": "Debe restablecer su contraseña.",
    "InvalidParameterException": "El parametro ingresado es invalido.",
    "InvalidPasswordException": "La contraseña debe contener una mayuscula, un numero y un caracter especial.",
    "LimitExceededException": "Demasiados intentos sucesivos, esperé unos minutos.",
    "CodeMismatchException": "El código ingresado es erroneo."
  };

  return translations[code] || "Error desconocido. Intenta nuevamente.";
}


